import { render, staticRenderFns } from "./CompanyShortlistsFooter.vue?vue&type=template&id=d02864f0&"
import script from "./CompanyShortlistsFooter.vue?vue&type=script&lang=js&"
export * from "./CompanyShortlistsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports